
<!-- Поправки на площадь и объем -->

<template>

	<div>
		<b-navbar class="p-0 pb-3">
			<b-navbar-brand class="p-0">
				<div v-if="has_history" class="d-flex align-items-center" style="gap: .75rem;">

					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>
					<h3>Поправки на площадь и объем</h3>

				</div>
				<h3 v-else >Поправки на площадь и объем</h3>
			</b-navbar-brand>
		</b-navbar>

		<b-tabs class="blue-500">

			<b-tab title="Поправки на площадь" active>

				<b-table ref="area_table" id="table" hover :items="corrections_area" :fields="fields" class="mt-2">

					<template v-slot:cell()="data">

						<table_input v-if="data.field.key === 'min'"
							:value="data.value" :item="data.item"
							v-on:change="value => set_value('area', data.item.index, data.field.key, value)"
							:validation="validation.min" :readonly="$root.not_editable || !check_roles([ 'model' ])"
						/>
						<table_input v-else
							:value="data.value" :item="data.item"
							v-on:change="value => set_value('area', data.item.index, data.field.key, value)"
							:validation="validation.correction" :readonly="$root.not_editable || !check_roles([ 'model' ])"
						/>

					</template>

				</b-table>

			</b-tab>

			<b-tab title="Поправки на объем">

				<b-table ref="volume_table" id="table" hover :items="corrections_volume" :fields="fields" class="mt-2">

					<template v-slot:cell()="data">

						<table_input v-if="data.field.key === 'min'"
							:value="data.value" :item="data.item"
							v-on:change="value => set_value('volume', data.item.index, data.field.key, value)"
							:validation="validation.min" :readonly="$root.not_editable || !check_roles([ 'model' ])"
						/>
						<table_input v-else
							:value="data.value" :item="data.item"
							v-on:change="value => set_value('volume', data.item.index, data.field.key, value)"
							:validation="validation.correction" :readonly="$root.not_editable || !check_roles([ 'model' ])"
						/>

					</template>

				</b-table>

			</b-tab>

		</b-tabs>

	</div>

</template>

<script>

import api from "../../../api"
import table_input from "../../widgets/table_input"

export default
{
	components :
	{
		table_input
	},
	data()
	{
		return {

			service : "cadastral_expensive",

			corrections_area : [],
			corrections_volume : [],
			fields :
			[
				{ key : "min", label : "Минимальное значение" },
				{ key : "correction", label : "Поправка" },
			],

			validation :
			{
				min :
				{
					check : (value) => api.check_number({ value, gte : 0 }),
					msg : "Больше или равно 0"
				},

				correction :
				{
					check : (value) => api.check_number({ value, gt : 0 }),
					msg : "Больше 0",
					gt_min : 0
				}
			}

		}
	},

	mounted()
	{
		this.refresh()
	},

	computed :
	{
		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		}
	},

	methods :
	{
		refresh()
		{
			var promises = [ api.call(this, this.service, "get_corrections", { type : "area"}, response => { this.corrections_area = response.data }), api.call(this, this.service, "get_corrections", { type : "volume"}, response => { this.corrections_volume = response.data }) ]

			Promise.all(promises)
				.then(() =>
				{
					var counter = 0

					this.corrections_area.forEach(correction =>
					{
						correction.index = counter
						counter ++
					})

					this.corrections_volume.forEach(correction =>
					{
						correction.index = counter
						counter ++
					})
				})
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		set_value(type, index, field, value)
		{
			if (!this.$root.not_editable && this.check_roles([ 'model' ]) && this.validation[field].check(value))
			{
				var corrections = this.corrections_area
				index = Number(index)
				const _value = Number(value)
	
				if(type == "volume")
					corrections = this.corrections_volume
	
				corrections.forEach(
					obj =>
					{
						if(obj.index == index)
							obj[field] = _value
					})

				api.call(this, this.service, "set_corrections", { type : type, value : corrections }, () => this.refresh())
			}
		},

		go_back()
		{
			api.back.go(this)
		}
	}
}

</script>

